export const content = {
    searchbarPlaceholder: 'Press enter to search',
}